import * as React from 'react';
import {Button, Card, CardBody, Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import inspectionConfirmImage from '../../assets/img/ic_inspection_confirm.png';
import PropTypes from 'prop-types';
import HorizontalLine from "../Widget/HorizontalLine";
// import label from "../../message/Label";
import label from 'enqc-utilities/src/label/Label'

import MyCardImage from "../Card/MyCardImage";


export default class ConfirmReleaseVerificationSubmitModal extends React.Component{

    render(){
        let {releaseVerification, releaseVerificationStatus} = this.props
        if(!releaseVerification){
            releaseVerification = {}
        }
        if(!releaseVerificationStatus){
            releaseVerificationStatus = {}
        }
        return (
            <Modal
                centered={true}
                isOpen={this.props.showing}
                backdrop={true}>
                <ModalHeader className="text-center w-100 d-block bg-header">
                    <span className="w-100 text-center h3" block>{label.ConfirmSubmission}</span>
                </ModalHeader>
                <ModalBody>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <MyCardImage style={{width:'240px'}} src={inspectionConfirmImage}/>
                        </CardBody>
                    </Card>
                    <br/>
                    <div className="font-weight-bolder" style={{textAlign:'center'}} dangerouslySetInnerHTML={{__html: label.YouWillSubmitReleaseVerificationWithReferenceVariableWithStatusVariable3_AreYouSure(releaseVerification.reference, label(releaseVerificationStatus.name))}} />
                    <br/>
                </ModalBody>
                <HorizontalLine/>
                <ModalBody>
                    <Row>
                        <Col>
                            <Button color="warning" onClick={e=>{
                                this.props.cancelCallback()
                            }}>
                                {label.Cancel}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                className={"float-right"}
                                color="primary" onClick={e=>{
                                this.props.okCallback(releaseVerification, releaseVerificationStatus)
                            }}>
                                {label.YesIamSure}
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}
ConfirmReleaseVerificationSubmitModal.propTypes = {
    releaseVerification:PropTypes.object.isRequired,
    releaseVerificationStatus:PropTypes.object.isRequired,
    showing:PropTypes.bool.isRequired,
    okCallback:PropTypes.func.isRequired,
    cancelCallback:PropTypes.func.isRequired,
    generateSerialNumber:PropTypes.bool.isRequired,
}
